import Logger from '../util/Logger';
import _ from 'lodash';
import DateTime from './DateTime';

export default {

  getEventId (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      const id = _.get(stats, 'event.event_id');
      if (!id) {
        Logger.assert('PulseStats was missing event_id');
      } else {
        return id;
      }
    }
  },

  getEventStartTime (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      const start = _.get(stats, 'event.start_date');
      if (!start) {
        Logger.assert('PulseStats was missing start_date');
      } else {
        const time = DateTime.fromTimeStamp(start);
        if (!time) {
          return null;
        } else {
          const zone = this.getEventTimeZone(stats);
          if (!zone) {
            return time;
          } else {
            return DateTime.applyTimeZone(time, zone);
          }
        }
      }
    }
  },

  getEventEndTime (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      const end = _.get(stats, 'event.end_date');
      if (!end) {
        Logger.assert('PulseStats was missing end_date');
      } else {
        const time = DateTime.fromTimeStamp(end);
        if (!time) {
          return null;
        } else {
          const zone = this.getEventTimeZone(stats);
          if (!zone) {
            return time;
          } else {
            return DateTime.applyTimeZone(time, zone);
          }
        }
      }
    }
  },

  getEventTimeZone (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      const zone = _.get(stats, 'event.time_zone');
      if (!zone) {
        Logger.error('event was missing time_zone', this.getEventId(stats));
        return null;
      } else {
        return zone;
      }
    }
  },

  getSimpleScore (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      const score = _.get(stats, 'summary.simple_score');
      if (!score) {
        return null;
      } else {
        return score;
      }
    }
  }

};
